import gql from 'graphql-tag';
import { CommentsFragments } from '@getaccept/lib-shared/src/contextual-commenting/graphql/comments.fragments';

export class CommentsQueries {
  static load = gql`
    query LoadContextualComments($limit: Float, $offset: Float, $statuses: [CommentStatus!]!) {
      contextualComments(limit: $limit, offset: $offset, statuses: $statuses) {
        ...commentFragment
      }
    }
    ${CommentsFragments.comment}
  `;

  static loadOne = gql`
    query LoadContextualComment($documentId: String!, $commentId: String!) {
      contextualComment(documentId: $documentId, commentId: $commentId) {
        ...commentFragment
      }
    }
    ${CommentsFragments.comment}
  `;
}
